"use strict";

var _classCallCheck = require("/Users/zero/localdev/personal/byoungz-gatsby/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/zero/localdev/personal/byoungz-gatsby/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SquareDrawer = void 0;
var fixFactor = Math.sqrt(2);

var SquareDrawer = /*#__PURE__*/function () {
  function SquareDrawer() {
    _classCallCheck(this, SquareDrawer);
  }

  _createClass(SquareDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 4;
    }
  }, {
    key: "draw",
    value: function draw(context, particle, radius) {
      context.rect(-radius / fixFactor, -radius / fixFactor, radius * 2 / fixFactor, radius * 2 / fixFactor);
    }
  }]);

  return SquareDrawer;
}();

exports.SquareDrawer = SquareDrawer;